var _title, _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgHelp = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "23px",
    height: "23px",
    viewBox: "0 0 23 23",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "Help")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Generic_DONE",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "03_UserOptions",
    transform: "translate(-1195.000000, -20.000000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Nav_Bar"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Help",
    transform: "translate(1190.000000, 15.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "help",
    transform: "translate(5.333333, 5.333333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.6630393,14.7477341 C10.0340198,14.7477341 9.52475421,15.2719528 9.52475421,15.9010153 C9.52475421,16.5150817 10.0190237,17.0542965 10.6630393,17.0542965 C11.307055,17.0542965 11.8163206,16.5151246 11.8163206,15.9010153 C11.8163206,15.2719528 11.2921448,14.7477341 10.6630393,14.7477341 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8577736,6.01571083 C8.83579309,6.01571083 7.90719541,7.21389443 7.90719541,8.02269521 C7.90719541,8.60685537 8.40142198,8.87644131 8.80584387,8.87644131 C9.6146017,8.87644131 9.28511732,7.72316006 10.8128283,7.72316006 C11.5617307,7.72316006 12.1608439,8.0526874 12.1608439,8.74164834 C12.1608439,9.5504921 11.3220939,10.0147694 10.8278244,10.4341444 C10.3934962,10.8085741 9.82433217,11.4226835 9.82433217,12.7107577 C9.82433217,13.4895663 10.0339767,13.7142499 10.6480861,13.7142499 C11.3819924,13.7142499 11.5317385,13.3847656 11.5317385,13.1001835 C11.5317385,12.321332 11.5467775,11.8720077 12.3705315,11.2279921 C12.7749104,10.9134609 14.0480315,9.89497257 14.0480315,8.4870585 C14.0480315,7.07914443 12.7749104,6.01571083 10.8577736,6.01571083 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11,0 C4.92060938,0 0,4.91979297 0,11 L0,21.140625 C0,21.6152578 0.384742187,22 0.859375,22 L11,22 C17.0793477,22 22,17.080207 22,11 C22,4.92060938 17.080207,0 11,0 Z M11,20.6666667 L1.33333333,20.6666667 L1.33333333,11 C1.33333333,5.6575108 5.65679475,1.33333333 11,1.33333333 C16.3424892,1.33333333 20.6666667,5.65679475 20.6666667,11 C20.6666667,16.3424892 16.3432052,20.6666667 11,20.6666667 Z",
    id: "Shape"
  }))))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgHelp, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/help.58d34ca7.svg";
export { ForwardRef as ReactComponent };